@if (!loggedInUser) {
  <div class="grid-container v-pad">
    <div class="centered-container">
      <div class="margin-top-large">
        @for (alert of alerts; track alert) {
          <div class="red">
            <h2 class="red" [innerHTML]="alert.title">
            </h2>
            <p [innerHTML]="alert.message">
            </p>
          </div>
        }
      </div>
      <h2 class="margin-top-large">Welcome to the Relationally Integrated Computer System (RICS)</h2>
      <p>If you are new to the site, please @if (cookiesAccepted) {
        <a [class.disabled]="anonymousSet ? null : true" [routerLink]="['/flow', 'create', 'nEftdz7nEftgODcOy']">Register!</a>
      } @else {
        <span class="faux-link" [class.disabled]="anonymousSet ? null : true" (click)="promptCookiesBeforeRegistration()">Register!</span>
        <a href="" style="display: none" #register [routerLink]="['/flow', 'create', 'nEftdz7nEftgODcOy']"></a>
      }</p>
      <p>
        If you have already registered, @if (cookiesAccepted) {
        <a href="/api/login">Login.</a>
      } @else {
        <span class="faux-link" (click)="promptCookiesBeforeLogin()">Login.</span>
        <a href="/api/login" style="display: none" #login></a>
      }
    </p>
    <p>
      The RICS Online System allows authorized entities to electronically interact with the Ohio Department of Natural Resources (ODNR),
      Division of Oil & Gas Resources Management (Division) to submit applications, file reports, comply with insurance and bonding
      requirements, and manage the entity's profile.
      <br />
      <br />
      Enjoy the benefits of electronic filing. Key benefits include:
    </p>
    <ul>
      <li>It's the fastest way to file</li>
      <li>Less costly than hand filing</li>
      <li>Provides more accuracy in tracking filings</li>
      <li>Increases data integrity</li>
      <li>Maximizes efficiency in managing filings</li>
      <li>Receive immediate confirmation that the Division has received your filing</li>
    </ul>
    <p align="left">We look forward to your registration and interaction with the RICS System.</p>
    @if (config?.allowExpiration) {
      <div>
        <p align="left">
          To ensure system security, your session will expire after {{config.idleTimeoutMinutes}} minutes of inactivity.
        </p>
      </div>
    }
    <h3 class="no-margin-bottom">Browser Compatibility</h3>
    <p>At the time of implementation of the Division's database, the database supports the most recent versions of the following browsers: Microsoft Edge, Google Chrome, Mozilla Firefox, and Apple Safari.   Please ensure that the following are enabled in the browser:  JavaScript, Cookies.</p>
  </div>
  @if (notFound) {
    <div class="centered-container-red">
      <p>You do not appear to be registered with the Division of Oil & Gas Resources Management.</p>
      <p>Please use this <a [routerLink]="['/flow', 'create', 'nEftdz7nEftgODcOy']"> link </a> to register with the division to gain access.</p>
    </div>
  }
</div>
}


